<div class="card product">
  <img *ngIf="note.imageUrl&&note.imageUrl.startsWith('http')" src="{{note.imageUrl}}" height="80" />
  <img *ngIf="note.imageUrl&&!note.imageUrl.startsWith('http')" src="{{ imageBaseUrl+note.imageUrl }}" height="80" />
  <p>{{ note.name }}</p>
</div>